import { Pipe, PipeTransform, inject } from '@angular/core';
import { CountryNameService } from './country-name.service';

@Pipe({
    name: 'countryName',
    standalone: true,
})
export class CountryNamePipe implements PipeTransform {

    private countryNameService = inject(CountryNameService);

    public transform(countryCode: string, type: 'combined' | 'translated' = 'translated'): string {
      return type === 'combined' ? this.countryNameService.getCombinedName(countryCode) : this.countryNameService.getName(countryCode);
    }

}
